var Request = require('../helper/request');

function Logo(app, branchId){
  var self = this;
  self.request = new Request(app);
  self.branchId = branchId;

  self.routes = {
    create: { 
      url: '/branch/'+self.branchId+'/logo',
      method: 'POST'
    },
    delete: {
      url: "/branch/"+self.branchId+"/logo",
      method: "DELETE"
    }
  };
}


Logo.prototype.create = function(data){
  var self = this;
  return self.request.post(self.routes.create.url, {
    logo: data
  });
}

Logo.prototype.delete = function(){
  var self = this;
  return self.request.delete(self.routes.delete.url);
}


module.exports = Logo;